export const roles = [
  { label: "Gratuito", value: "free student" },
  { label: "Premium", value: "pro student" },
  { label: "Administrador", value: "admin" },
];
